import React from 'react';
import { ConfirmDialog } from 'swag-client-common/components/info/confirm-dialog';
import css from './confirm-change-super-speed-prod-time-popup.scss';
export const ConfirmChangeSuperSpeedProdTimeComponent = ({
  open,
  message,
  message2,
  title,
  params,
  onClose,
  onConfirm,
  isOnCheckout = false
}) => /*#__PURE__*/React.createElement(ConfirmDialog, {
  open: open,
  title: title,
  onCancel: () => onClose(params),
  onConfirm: () => {
    return onConfirm(params, isOnCheckout);
  },
  msg: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: css.textBlockOne
  }, message), message2 && /*#__PURE__*/React.createElement("span", null, message2))
});